import {createTheme} from '@mui/material/styles'

export const endpoint = 'https://217c140d-9b53-42c9-9b98-8e9c71391b78.mock.pstmn.io/v1/videos'
// export const endpoint = "https://xflix-node-swarup.herokuapp.com/v1/videos"
// export const endpoint = 'http://localhost:8082/v1/videos'
// export const endpoint = 'http://15.207.190.175:8082/v1/videos'

export const themeOptions = {
  palette: {
    type: 'dark',
    primary: {
      main: '#434343',
    },
    secondary: {
      main: '#ffffff',
    },
    background: {
      paper: '#434343'
    }
  },
    // palette: {
    //   type: 'dark',
    //   primary: {
    //     main: '#414141',
    //     light: '#414141',
    //     dark: '#414141',
    //   },
    //   secondary: {
    //     main: '#ee1520',
    //     light: '#ee1520',
    //     dark: '#ee1520',
    //   },
    //   background: {
    //     default: '#121212',
    //     paper: '#121212',
    //   },
    //   text: {
    //     primary: '#ffffff',
    //     secondary: '#ffffff',
    //     disabled: 'rgba(255,255,255,0.7)',
    //     hint: '#ffffff',
    //   },
    //   divider: '#ffffff',
    // },
  };

export const theme = createTheme(themeOptions)